export const recommendationsResponseBody = {
  products: [
    {
      title: "'You Mean The World To Me/Us' Keyring",
      available: true,
      partner: {
        shortcode: 'kutuu',
        name: 'Kutuu',
        links: [
          {
            href: 'https://www.public.shared.qa.noths.com/kutuu',
            rel: '/kutuu',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/kutuu/product/you-mean-the-world-to-me-keyring',
          rel: '/kutuu/product/you-mean-the-world-to-me-keyring',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: true,
      images: [
        {
          title: "'You Mean The World To Me/Us' Keyring",
          href: 'https://cdn.notonthehighstreet.com/fs/02/ee/8042-c959-43f5-8aed-6888db4fcdde/{size}_you-mean-the-world-to-me-keyring.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 4.9,
        ratingCount: 481,
        ratingHistogram: [4, 0, 1, 51, 425],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['kutuu'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Kutuu'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2015-06-03 13:02:58.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        highly_rated: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        star_brand: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        delivery_cost: {
          numbers: [3.99],
          searchable: true,
          indexable: true,
        },
        delivery_days: {
          numbers: [4],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        currency: 'GBP',
        amount: 1200,
        exponent: 2,
      },
      prices: [
        {
          currency: 'GBP',
          amount: 1200,
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 478341,
    },
    {
      title: 'Dachshund / Sausage Dog Organic Cotton Apron',
      available: false,
      partner: {
        shortcode: 'sweetwilliamdesigns',
        name: 'Sweet William Designs',
        links: [
          {
            href: 'https://www.public.shared.qa.noths.com/sweetwilliamdesigns',
            rel: '/sweetwilliamdesigns',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/sweetwilliamdesigns/product/dachshund-sausage-dog-apron',
          rel: '/sweetwilliamdesigns/product/dachshund-sausage-dog-apron',
        },
      ],
      isNew: false,
      purchasable: false,
      freeDomesticDelivery: false,
      images: [
        {
          title: 'Dachshund / Sausage Dog Organic Cotton Apron',
          href: 'https://cdn.notonthehighstreet.com/system/product_images/images/001/792/281/{size}_dachshund-sausage-dog-apron.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'out_of_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 4.9,
        ratingCount: 10,
        ratingHistogram: [0, 0, 0, 1, 9],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['out_of_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['sweetwilliamdesigns'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Sweet William Designs'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2014-09-05 14:07:35.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        currency: 'GBP',
        amount: 2995,
        exponent: 2,
      },
      prices: [
        {
          currency: 'GBP',
          amount: 2995,
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 375634,
    },
    {
      title: 'Personalised Solid Copper Photo Print',
      available: true,
      partner: {
        shortcode: 'oakdenedesigns',
        name: 'Oakdene Designs',
        links: [
          {
            href: 'https://www.public.shared.qa.noths.com/oakdenedesigns',
            rel: '/oakdenedesigns',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/oakdenedesigns/product/personalised-solid-copper-photo-print',
          rel: '/oakdenedesigns/product/personalised-solid-copper-photo-print',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: true,
      images: [
        {
          title: 'Personalised Solid Copper Photo Print',
          href: 'https://cdn.notonthehighstreet.com/fs/58/92/c9a5-1c0d-4e25-b270-9c7aa728ab11/{size}_personalised-solid-copper-photo-print.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 4.7,
        ratingCount: 1504,
        ratingHistogram: [21, 45, 3, 178, 1257],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['oakdenedesigns'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Oakdene Designs'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2016-05-25 10:30:47.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        highly_rated: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        star_brand: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        delivery_cost: {
          numbers: [0],
          searchable: true,
          indexable: true,
        },
        delivery_days: {
          numbers: [2],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        currency: 'GBP',
        amount: 3200,
        exponent: 2,
      },
      prices: [
        {
          currency: 'GBP',
          amount: 3200,
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 596731,
    },
    {
      title: 'Midi Buck Toy Racing Car',
      available: false,
      partner: {
        shortcode: 'meandmycar',
        name: 'Me and My Car',
        links: [
          {
            href: 'https://www.public.shared.qa.noths.com/meandmycar',
            rel: '/meandmycar',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/meandmycar/product/midi-buck-racing-car',
          rel: '/meandmycar/product/midi-buck-racing-car',
        },
      ],
      isNew: false,
      purchasable: false,
      freeDomesticDelivery: true,
      images: [
        {
          title: 'Midi Buck Toy Racing Car',
          href: 'https://cdn.notonthehighstreet.com/fs/72/0c/57b7-6d5d-404a-b0d8-2aefb2fedac3/{size}_midi-buck-racing-car.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'out_of_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 5,
        ratingCount: 1,
        ratingHistogram: [0, 0, 0, 0, 1],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['out_of_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['meandmycar'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Me and My Car'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2015-02-11 15:10:11.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        currency: 'GBP',
        amount: 4900,
        exponent: 2,
      },
      prices: [
        {
          currency: 'GBP',
          amount: 4900,
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 434578,
    },
    {
      title: 'Classic Bentley Car Cufflinks',
      available: true,
      partner: {
        shortcode: 'meandmycar',
        name: 'Me and My Car',
        links: [
          {
            href: 'https://www.public.shared.qa.noths.com/meandmycar',
            rel: '/meandmycar',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/meandmycar/product/classic-bentley-cufflinks',
          rel: '/meandmycar/product/classic-bentley-cufflinks',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: true,
      images: [
        {
          title: 'Classic Bentley Car Cufflinks',
          href: 'https://cdn.notonthehighstreet.com/fs/89/72/d4bd-a122-47de-b69b-3347fcbbe984/{size}_classic-bentley-cufflinks.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: true,
      lowCommitmentProductType: 'low commitment product',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 4.5,
        ratingCount: 2,
        ratingHistogram: [0, 0, 0, 1, 1],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['meandmycar'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Me and My Car'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2016-02-12 11:11:33.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        currency: 'GBP',
        amount: 3000,
        exponent: 2,
      },
      prices: [
        {
          currency: 'GBP',
          amount: 3000,
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 566407,
    },
    {
      title: "Mum's Or Dad's Kitchen 'Café' Chalkboard Print",
      available: true,
      partner: {
        shortcode: 'inkandsons',
        name: 'Ink & Sons',
        links: [
          {
            href: 'https://www.public.shared.qa.noths.com/inkandsons',
            rel: '/inkandsons',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/inkandsons/product/mum-s-cafe-print',
          rel: '/inkandsons/product/mum-s-cafe-print',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: true,
      images: [
        {
          title: "Mum's Or Dad's Kitchen 'Café' Chalkboard Print",
          href: 'https://cdn.notonthehighstreet.com/system/product_images/images/001/522/906/{size}_mum-s-cafe-print.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.25,
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['inkandsons'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Ink & Sons'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2014-02-26 11:13:01.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        currency: 'GBP',
        amount: 1800,
        exponent: 2,
      },
      prices: [
        {
          currency: 'GBP',
          amount: 1800,
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 320703,
    },
  ],
  metadata: {
    attributionToken:
      'ChQxMjk5ODY4NDE0OTY1MzQ1NzE4MhACGgJSViIfZGVmYXVsdF9wcm9kdWN0X3JlY29tbWVuZGF0aW9ucygAOiCt8tES9_HRErTx0RKM8tESsvHREqny0RKP8tES-vHREg',
    missingIds: ['1508010'],
    validateOnly: true,
  },
};

export const recommendationsResponseBodySaleAUD = {
  products: [
    {
      title: 'Personalised Enamel Snack Pot',
      available: true,
      partner: {
        shortcode: 'sophiavictoriajoy',
        name: 'Sophia Victoria Joy',
        links: [
          {
            href: 'https://www.notonthehighstreet.com/sophiavictoriajoy',
            rel: '/sophiavictoriajoy',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/sophiavictoriajoy/product/personalised-enamel-snack-pot',
          rel: '/sophiavictoriajoy/product/personalised-enamel-snack-pot',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: false,
      images: [
        {
          title: 'Personalised Enamel Snack Pot',
          href: 'https://cdn.notonthehighstreet.com/fs/96/b3/a369-d15d-4637-ac9e-ce8c429671a2/{size}_personalised-enamel-snack-pot.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 4.4,
        ratingCount: 329,
        ratingHistogram: [13, 10, 34, 40, 232],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['sophiavictoriajoy'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Sophia Victoria Joy'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2018-07-26 10:48:13.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        amount: 2216,
        currency: 'AUD',
        exponent: 2,
      },
      prices: [
        {
          amount: 1200,
          currency: 'GBP',
          exponent: 2,
        },
        {
          amount: 2216,
          currency: 'AUD',
          exponent: 2,
        },
        {
          amount: 1364,
          currency: 'EUR',
          exponent: 2,
        },
        {
          amount: 1484,
          currency: 'USD',
          exponent: 2,
        },
      ],
      preSalePrices: [
        {
          amount: 2400,
          currency: 'GBP',
          exponent: 2,
        },
        {
          amount: 4432,
          currency: 'AUD',
          exponent: 2,
        },
        {
          amount: 2729,
          currency: 'EUR',
          exponent: 2,
        },
        {
          amount: 2969,
          currency: 'USD',
          exponent: 2,
        },
      ],
      onSale: true,
      salePercentage: 50,
      code: 804990,
      isExpandedSearch: false,
    },
    {
      title: 'Personalised Olive Wood Wedding Gift Chopping Board',
      available: true,
      partner: {
        shortcode: 'therusticdish',
        name: 'The Rustic Dish®',
        links: [
          {
            href: 'https://www.notonthehighstreet.com/therusticdish',
            rel: '/therusticdish',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/therusticdish/product/personalised-couples-cheese-chopping-board',
          rel: '/therusticdish/product/personalised-couples-cheese-chopping-board',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: true,
      images: [
        {
          title: 'Personalised Olive Wood Wedding Gift Chopping Board',
          href: 'https://cdn.notonthehighstreet.com/fs/11/14/205a-a483-4f7c-9a5c-7cfc11ecb458/{size}_personalised-couples-cheese-chopping-board.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 4.8,
        ratingCount: 79,
        ratingHistogram: [2, 1, 0, 3, 73],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['therusticdish'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['The Rustic Dish®'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2018-01-08 18:53:41.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        amount: 5169,
        currency: 'AUD',
        exponent: 2,
      },
      prices: [
        {
          amount: 2799,
          currency: 'GBP',
          exponent: 2,
        },
        {
          amount: 5169,
          currency: 'AUD',
          exponent: 2,
        },
        {
          amount: 3182,
          currency: 'EUR',
          exponent: 2,
        },
        {
          amount: 3462,
          currency: 'USD',
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 764151,
      isExpandedSearch: false,
    },
    {
      title: 'Family Birthstone Link Bracelet',
      available: true,
      partner: {
        shortcode: 'joybycorrinesmith',
        name: 'Joy by Corrine Smith',
        links: [
          {
            href: 'https://www.notonthehighstreet.com/joybycorrinesmith',
            rel: '/joybycorrinesmith',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/joybycorrinesmith/product/family-birthstone-link-bracelet',
          rel: '/joybycorrinesmith/product/family-birthstone-link-bracelet',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: true,
      images: [
        {
          title: 'Family Birthstone Link Bracelet',
          href: 'https://cdn.notonthehighstreet.com/fs/47/23/a76a-eaa8-4c38-904d-ca97ffe5b197/{size}_family-birthstone-link-bracelet.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.35,
      ratings: {
        averageRating: 4.8,
        ratingCount: 936,
        ratingHistogram: [9, 11, 13, 107, 796],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.35],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['joybycorrinesmith'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Joy by Corrine Smith'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2015-05-09 17:00:11.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        amount: 4801,
        currency: 'AUD',
        exponent: 2,
      },
      prices: [
        {
          amount: 2600,
          currency: 'GBP',
          exponent: 2,
        },
        {
          amount: 4801,
          currency: 'AUD',
          exponent: 2,
        },
        {
          amount: 2956,
          currency: 'EUR',
          exponent: 2,
        },
        {
          amount: 3216,
          currency: 'USD',
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 469358,
      isExpandedSearch: false,
    },
    {
      title: 'Personalised Pull Out Photo Album Token Gift',
      available: true,
      partner: {
        shortcode: 'sophiavictoriajoy',
        name: 'Sophia Victoria Joy',
        links: [
          {
            href: 'https://www.notonthehighstreet.com/sophiavictoriajoy',
            rel: '/sophiavictoriajoy',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/sophiavictoriajoy/product/personalised-pull-out-photo-album-token-gift',
          rel: '/sophiavictoriajoy/product/personalised-pull-out-photo-album-token-gift',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: false,
      images: [
        {
          title: 'Personalised Pull Out Photo Album Token Gift',
          href: 'https://cdn.notonthehighstreet.com/fs/d2/c0/3aed-b8b6-4b11-b894-591a2914760f/{size}_personalised-pull-out-photo-album-token-gift.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: true,
      lowCommitmentProductType: 'cards',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 4.7,
        ratingCount: 854,
        ratingHistogram: [17, 13, 13, 81, 730],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['sophiavictoriajoy'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Sophia Victoria Joy'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2018-05-31 11:59:14.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['cards'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        amount: 2031,
        currency: 'AUD',
        exponent: 2,
      },
      prices: [
        {
          amount: 1100,
          currency: 'GBP',
          exponent: 2,
        },
        {
          amount: 2031,
          currency: 'AUD',
          exponent: 2,
        },
        {
          amount: 1251,
          currency: 'EUR',
          exponent: 2,
        },
        {
          amount: 1361,
          currency: 'USD',
          exponent: 2,
        },
      ],
      preSalePrices: [
        {
          amount: 2200,
          currency: 'GBP',
          exponent: 2,
        },
        {
          amount: 4063,
          currency: 'AUD',
          exponent: 2,
        },
        {
          amount: 2501,
          currency: 'EUR',
          exponent: 2,
        },
        {
          amount: 2721,
          currency: 'USD',
          exponent: 2,
        },
      ],
      onSale: true,
      salePercentage: 50,
      code: 801933,
      isExpandedSearch: false,
    },
    {
      title: 'Personalised Vintage Map Picture With Stitched Heart',
      available: true,
      partner: {
        shortcode: 'poshtottydesignscreates',
        name: 'Posh Totty Designs Creates',
        links: [
          {
            href: 'https://www.notonthehighstreet.com/poshtottydesignscreates',
            rel: '/poshtottydesignscreates',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/poshtottydesignscreates/product/personalised-vintage-map-picture-with-stitched-heart',
          rel: '/poshtottydesignscreates/product/personalised-vintage-map-picture-with-stitched-heart',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: true,
      images: [
        {
          title: 'Personalised Vintage Map Picture With Stitched Heart',
          href: 'https://cdn.notonthehighstreet.com/fs/f1/ef/04e4-72b3-4f06-bedd-65c962371130/{size}_personalised-vintage-map-picture-with-stitched-heart.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.35,
      ratings: {
        averageRating: 4.9,
        ratingCount: 58,
        ratingHistogram: [0, 0, 3, 2, 53],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.35],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['poshtottydesignscreates'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Posh Totty Designs Creates'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2023-04-14 09:19:46.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        amount: 6463,
        currency: 'AUD',
        exponent: 2,
      },
      prices: [
        {
          amount: 3500,
          currency: 'GBP',
          exponent: 2,
        },
        {
          amount: 6463,
          currency: 'AUD',
          exponent: 2,
        },
        {
          amount: 3980,
          currency: 'EUR',
          exponent: 2,
        },
        {
          amount: 4329,
          currency: 'USD',
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 1290730,
      isExpandedSearch: false,
    },
    {
      title: 'Sterling Silver Birthstone Sliding Bracelet',
      available: true,
      partner: {
        shortcode: 'gaamaa',
        name: 'Gaamaa',
        links: [
          {
            href: 'https://www.notonthehighstreet.com/gaamaa',
            rel: '/gaamaa',
          },
        ],
      },
      links: [
        {
          href: 'https://notonthehighstreet.com/gaamaa/product/sterling-silver-birthstone-sliding-bracelet',
          rel: '/gaamaa/product/sterling-silver-birthstone-sliding-bracelet',
        },
      ],
      isNew: false,
      purchasable: true,
      freeDomesticDelivery: true,
      images: [
        {
          title: 'Sterling Silver Birthstone Sliding Bracelet',
          href: 'https://cdn.notonthehighstreet.com/fs/6d/f2/4aae-81c5-4274-b2fe-a4621dce5edb/{size}_sterling-silver-birthstone-sliding-bracelet.jpg',
          gravity: 'north',
        },
      ],
      inventoryStatus: 'in_stock',
      lowCommitmentProductFlag: false,
      lowCommitmentProductType: 'not low commitment product',
      actualCommissionRate: 0.25,
      ratings: {
        averageRating: 4.9,
        ratingCount: 2342,
        ratingHistogram: [18, 12, 18, 178, 2116],
      },
      attributes: {
        actual_comms_rate: {
          numbers: [0.25],
          searchable: true,
          indexable: true,
        },
        inventory_status: {
          text: ['in_stock'],
          searchable: true,
          indexable: true,
        },
        partner_shortcode: {
          text: ['gaamaa'],
          searchable: true,
          indexable: true,
        },
        partner_name: {
          text: ['Gaamaa'],
          searchable: true,
          indexable: true,
        },
        is_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        is_partner_active: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        published_at: {
          text: ['2018-04-02 11:47:54.000 Z'],
          searchable: true,
          indexable: true,
        },
        delivery_free: {
          text: ['true'],
          searchable: true,
          indexable: true,
        },
        image_gravity: {
          text: ['north'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_fl: {
          text: ['false'],
          searchable: true,
          indexable: true,
        },
        low_commitment_product_type: {
          text: ['not low commitment product'],
          searchable: true,
          indexable: true,
        },
      },
      price: {
        amount: 5171,
        currency: 'AUD',
        exponent: 2,
      },
      prices: [
        {
          amount: 2800,
          currency: 'GBP',
          exponent: 2,
        },
        {
          amount: 5171,
          currency: 'AUD',
          exponent: 2,
        },
        {
          amount: 3184,
          currency: 'EUR',
          exponent: 2,
        },
        {
          amount: 3463,
          currency: 'USD',
          exponent: 2,
        },
      ],
      preSalePrices: [],
      onSale: false,
      salePercentage: 0,
      code: 786481,
      isExpandedSearch: false,
    },
  ],
  metadata: {
    attributionToken:
      'ChQxNTk0OTQ3NTY4NzU3MjE5OTUwMhACGiNyZWNvbW1lbmRlX3JlY29tbWVuZGVfMTczNzEzNzI0NTEwMyIWZGVmYXVsdF9yZWNvbW1lbmRhdGlvbigAOiCt8tEStPHREvfx0RKp8tESsvHREozy0RKP8tES-vHREg',
    missingIds: ['1508010'],
    validateOnly: true,
  },
};
